import { render, staticRenderFns } from "./accident.vue?vue&type=template&id=0725c1db"
import script from "./accident.vue?vue&type=script&lang=js"
export * from "./accident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0725c1db')) {
      api.createRecord('0725c1db', component.options)
    } else {
      api.reload('0725c1db', component.options)
    }
    module.hot.accept("./accident.vue?vue&type=template&id=0725c1db", function () {
      api.rerender('0725c1db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/accident.vue"
export default component.exports